import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "space-between" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 닫기 ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_text = _resolveComponent("ag-text")!
  const _component_ag_box = _resolveComponent("ag-box")!

  return (_openBlock(), _createBlock(_component_ag_box, { px: "20px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ag_text, {
          color: "black",
          typography: 'main16r'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.titleRef), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ag_text, {
          color: "black",
          typography: 'main16r',
          onClick: _ctx.modalClose
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _hoisted_3
    ]),
    _: 1
  }))
}